import { render } from "./ConnectionLost.vue?vue&type=template&id=405ea1e4"
const script = {}

import exportComponent from "/home/nicolas-choquet/www/play-private-store/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__